import React from "react";
import UserCourseCard from "components/CourseBuilder/UserCourseCard/UserCourseCard";
import { useTeamContext } from "store/contexts/teamContext";
import { useSelector } from "react-redux";
import Loader from "components/Loader";

export default ({ courses, total, calculateProgress, getStatus }) => {
  const { team } = useTeamContext();
  const { isLoading } = useSelector((state) => state.myCoursesReducer);
  
  const noCourses = {
    display: "flex",
    width: "100%",
    justifyContent: "center",
    padding: "100px 0",
    fontSize: "22px",
    fontWeight: "500",
  };

  const loaderStyle = {
    display: "flex",
    justifyContent: "center",
    width: "100%",
    padding: "100px 0",
  };

  return (
    <div className="courses-cards">
      <div className="row courseRow">
        {courses.map((course, index) => {
          const progress = calculateProgress(course.id);
          const status = getStatus(course.id);
          
          return (
            <UserCourseCard 
              key={course.id} 
              course={course} 
              index={index} 
              teamId={team?.id}
              progress={progress}
              status={status}
            />
          );
        })}
      </div>
      {isLoading && <div style={loaderStyle}><Loader /></div>}
      {!isLoading && (courses.length === 0 || total === 0) && <div style={noCourses}>You don't have any Courses</div>}
    </div>
  );
}; 